import { defineMessages } from 'react-intl'

export default defineMessages({
  'heftyMap.farm': {
    id: 'heftyMap.farm',
    defaultMessage: 'Farm',
  },
  'heftyMap.field': {
    id: 'heftyMap.field',
    defaultMessage: 'Field',
  },
  'heftyMap.area': {
    id: 'heftyMap.area',
    defaultMessage: 'Area',
  },
  'heftyMap.acres': {
    id: 'heftyMap.acres',
    defaultMessage: 'acres',
  },
  'heftyMap.hectares': {
    id: 'heftyMap.hectares',
    defaultMessage: 'hectares',
  },
  'thisFieldMustBeUnique': {
    id: 'thisFieldMustBeUnique',
    defaultMessage: 'A job is already assigned to this field.',
  },
  'bagIdIsRequired': {
    id: 'bagIdIsRequired',
    defaultMessage: "ID can't be blank",
  },
  'bagIdIsRedundant': {
    id: 'bagIdIsRedundant',
    defaultMessage: 'Already exists',
  },
  'bagIdIsTooLong': {
    id: 'bagIdIsTooLong',
    defaultMessage: '10 symbols max',
  },
})
